import { useHistory } from 'react-router-dom';

export default function useNavegacao() {
    const history = useHistory();

    function navegarParaListaContratos(){
        history.push('/lista-contratos');
    }

    function navegarParaVisualizarContrato(inscricao){
        history.push(`/assinatura/${inscricao}`);
    }

    function navegarParaEditarContrato(inscricao){
        history.push(`/editar-contrato/${inscricao}`);
    }

    function navegarParaCadastrarDependentes(inscricao){
        history.push(`/cadastrar-dependentes/${inscricao}`);
    }

    function navegarParaCadastrarServicosAdicionais(inscricao){
        history.push(`/cadastrar-servicos-adicionais/${inscricao}`);
    }

    function navegarParaCobrancaAssociado(inscricao){
        history.push(`/cobranca-assoc/${inscricao}`);
    }

    function navegarParaVisualizarAssociado(inscricao){
        history.push(`/visualizar-assoc/${inscricao}`);
    }

    function navegarParaPaginaAnterior(){
        history.goBack();
    }

    function navegarParaHome(){
        history.push('/');
    }

    function navegarParaCadastroAdesaoEmLote(){
        history.push('cadastro-edicao-precos');
    }

    function navegarParaCadastroMensalidadeEmLote(){
        history.push('cadastro-edicao-precos-mensalidades');
    }

    return {
        navegarParaListaContratos,
        navegarParaVisualizarContrato,
        navegarParaEditarContrato,
        navegarParaCadastrarDependentes,
        navegarParaCadastrarServicosAdicionais,
        navegarParaCobrancaAssociado,
        navegarParaVisualizarAssociado,
        navegarParaPaginaAnterior,
        navegarParaHome,
        navegarParaCadastroAdesaoEmLote,
        navegarParaCadastroMensalidadeEmLote
    };
}
